import { Component, Input } from '@angular/core';
import { NavigationService } from 'services/navigation.service';
import { ProductPlanModel } from 'models/generated/Entities.GormCrm.ProductPlan';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CompanyProductsListComponent } from 'components/company/company-products-list.component';
import { CompanyDataProvider, CompanyDataProviderFactory } from 'services/company-data-provider';
import { ProductPlanService } from 'services/productplan.service';
import { ProductPlanTagConstants } from 'constants/ProductPlanTagConstants';

@Component({
	selector: 'syncronize-plans-to-standout-crm',
	templateUrl: './syncronize-plans-to-standout-crm.component.html',
	providers: [CompanyDataProviderFactory],
	imports: [Layout, TranslatePipe, CompanyProductsListComponent]
})
export class SyncronizePlansToStandoutCrmComponent {

	dataProvider?: CompanyDataProvider;
	allPlans: ProductPlanModel[] = [];
	loading: boolean = true;
	planTagsForStandoutSyncronization: string[] = [];
	selectedProductPlans: ProductPlanModel[] = [];

	private _companyId!: string;
	@Input()
	set companyId(id: string) {
		this._companyId = id;
		this.dataProvider = this.dataProviderFactory.getProviderForCompanyId(id);
		this.loadPlans();
	}
	get companyId() {
		return this._companyId;
	}

	constructor(private readonly dataProviderFactory: CompanyDataProviderFactory,
		private readonly navigation: NavigationService,
		private readonly productPlanService: ProductPlanService) {

	}

	async loadPlans() {
		this.selectedProductPlans = [];
		this.allPlans = await this.dataProvider!.getAllProductPlansAndAccountingPlans();
		this.allPlans.filter(plan => this.isSelectable(plan)).forEach(plan => this.selectedProductPlans.push(plan));
		this.loading = false;
	}

	isSelectable = (plan: ProductPlanModel) => {
		if (!plan.autoRenewable) return false;
		if (!plan.autoRenewalDate || plan.autoRenewalDate < new Date()) return false;
		if (plan.productPlanTags.map(t => t.tag).includes(ProductPlanTagConstants.standoutSyncActive)) return false;
		if (!plan.productPlanTags.some(t => this.planTagsForStandoutSyncronization.includes(t.tag))) return false;
		return true;
	}

	cancel() {
		this.navigation.closeView(this);
	}

	async submitSelectedPlansToSynchronization() {
		if (this.selectedProductPlans.length == 0) return;
		await this.productPlanService.addProductPlansToStandoutSync(this.selectedProductPlans.map(pp => pp.id!));
		this.navigation.closeView(this);
	}
}
